export default __webpack_public_path__ + "static/men-bodymap-posterior-369e6b47e7ae585ed9c58f39a3dfdf0a.webp";